import { AuthService } from './authentication/auth.service';
import { ConsoleLogService, LogService } from './logging';
import { throwIfAlreadyLoaded } from './module-import-guard';
import * as coreStore from './store';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { MsalGuard, MsalBroadcastService } from '@azure/msal-angular';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

const PROVIDERS = [
  { provide: LogService, useClass: ConsoleLogService },
  AuthService,
  MsalGuard,
  MsalBroadcastService,
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(coreStore.coreFeatureName, coreStore.coreReducers),
    EffectsModule.forFeature([...coreStore.coreEffects]),
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }

  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [...PROVIDERS],
    };
  }
}
